"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default_gripper = exports.axes_to_arr = void 0;
const axes_to_arr = (ax) => {
    return [ax.X, ax.Y, ax.Z, ax.Rotation];
};
exports.axes_to_arr = axes_to_arr;
const default_gripper = () => {
    return {
        x_low: 200,
        x_high: 200,
        y_low: 100,
        y_high: 100,
        SuctionOutput: -1,
        PressureInput: -1,
    };
};
exports.default_gripper = default_gripper;
